import Decimal from 'decimal.js';

export function formatPercent(value: Decimal, decimalPlaces = 6) {
  return value.toFixed(decimalPlaces);
}

export function formatPercentNoDecimals(value: Decimal) {
  return value.toFixed(0);
}

/**
 * Smart percentage formatting for display surfaces:
 * - Round numbers (e.g. 100, 50) → 0 decimal places ("100%", "50%")
 * - Non-round numbers → 2 decimal places ("33.33%", "16.67%")
 */
export function formatPercentSmart(value: Decimal): string {
  const isRound = value.decimalPlaces() === 0;
  return value.toFixed(isRound ? 0 : 2);
}
